

import { axiosBitrixInstance } from "../../../utils/axios/requestInfo";
import { generateGuid } from "../../../helpers/generateGuid";
import { getMoscowDate } from "../../../helpers/dateFormatter";
import { cleanPhone } from "../../../utils/form/phoneFormat";
import { api } from "../../../resources/api";

export interface BitrixRegisterParams {
  phone: string;
  name: string;
  email: string;
  skipPartnerIdCheck?: boolean;
}

export const bitrixRegister = async (
  phone: string,
  name: string,
  email: string,
  skipPartnerIdCheck: boolean = false
): Promise<string | number> => {
  let nameTemp: string[] = [];

  const cleanedPhone = cleanPhone(phone);

  const guid = generateGuid({ phone: cleanedPhone, name, email });

  if (name.split(' ').length > 1) {
    nameTemp = name.split(' ');
  } else {
    nameTemp[0] = name;
    nameTemp[1] = '';
  }

  return await axiosBitrixInstance
    .post(
      api.bitrix.CREATE_MODIFY_PARTNER,
      {
        name: nameTemp[0],
        surname: nameTemp[1],
        phone: cleanedPhone,
        email: email,
        changeDate: getMoscowDate(),
        guid: guid,
      },
      {
        skipPartnerIdCheck: skipPartnerIdCheck,
      } as any
    )
    .then((response) => {
      return response.data.partnerId;
    })
    .catch((error) => {
      throw error;
    });
};

